import { Trans } from 'react-i18next'
import { StyleSheet, View, ViewProps } from 'react-native'
import { Spacing, Text } from 'zens-storybook'

const styles = StyleSheet.create({
  container: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
  }
})

interface Props extends ViewProps {}

const GeneralErrorScreen = (props: Props) => {
  const { style, ...otherProps } = props

  return (
    <View style={[styles.container, style]} {...otherProps}>
      <View>
        <Text level={1}>
          <Trans>The link has expired</Trans>
        </Text>
      </View>
      <Text>
        <Trans>Please contact our support team</Trans>
      </Text>
    </View>
  )
}

export default GeneralErrorScreen
